<template>
    <Container padding="none" height="with-footer" class="pt-(--header-height)">
        <Head>
            <Title>{{ t("category.page.title") }}</Title>
            <Meta name="description" :content="t('category.page.description')" />
        </Head>
        <div class="py-4">
            <CreateBreadcrumb :list="breadcrumbs" :max-items="5" />
        </div>
        <div class="pt-8 pb-16">
            <PageCategoriesList :list="list" :loading="pending" />
        </div>
    </Container>
</template>

<script lang="ts" setup>
import { CreateBreadcrumb } from "~/components/ui/breadcrumb";

const { t } = useI18n();
const { data: categories, pending } = useCategories();

const list = computed(() => useFilter(categories.value?.data, (e: APICategory) => e.parent === undefined) || new Array(4));

const breadcrumbs = [
    {
        label: t("general.home"),
        to: "/",
        icon: {
            name: "majesticons:home",
        },
    },
    {
        label: t("general.categories"),
        icon: {
            name: "majesticons:tickets-line",
        },
    },
];
</script>

<style></style>
